const AYANA_KOMODO = "AYANA Komodo Waecicu Beach";
const AYANA_LAKODIA = "AYANA Lako Di'a";
const AYANA_BALI = "AYANA Bali";
const AYANA_RESORT_AND_SPA = "AYANA Resort Bali";
const RIMBA_JIMBARAN_BALI = "RIMBA by AYANA Bali";
const VILLAS_AYANA_RESORT_BALI = "AYANA Villas Bali";

const AYANA_KOMODO_ID = "4";
const AYANA_LAKODIA_ID = "5";
const AYANA_RESORT_ID = "2";
const AYANA_RIMBA_JIMBARAN_ID = "1";
const AYANA_VILLA_ID = "3";
const AYANA_JAKARTA_ID = "7";

const BALI_FOOTER_DESTINATION = "Bali_Footer_Destination";
const KOMODO_FOOTER_DESTINATION = "Komodo_Footer_Destination";
const LAKODIA_FOOTER_DESTINATION = "LKD_Footer_Destination";

const GENERAL_INQUIRY = "generalInquiry";
const STAY_VOUCHER_INQUIRY = "stayVoucherInquiry";
const CRUISE_INQUIRY = "cruiseInquiry";
const EXPERIENCE_INQUIRY = "experience";
const DAILY_BOAT_TRIP_INQUIRY = "dailyBoatTrips";

module.exports = {
  AYANA_KOMODO,
  AYANA_LAKODIA,
  AYANA_BALI,
  AYANA_RESORT_AND_SPA,
  RIMBA_JIMBARAN_BALI,
  VILLAS_AYANA_RESORT_BALI,
  AYANA_KOMODO_ID,
  AYANA_LAKODIA_ID,
  AYANA_RESORT_ID,
  AYANA_RIMBA_JIMBARAN_ID,
  AYANA_VILLA_ID,
  BALI_FOOTER_DESTINATION,
  KOMODO_FOOTER_DESTINATION,
  LAKODIA_FOOTER_DESTINATION,
  GENERAL_INQUIRY,
  STAY_VOUCHER_INQUIRY,
  CRUISE_INQUIRY,
  EXPERIENCE_INQUIRY,
  DAILY_BOAT_TRIP_INQUIRY,
  AYANA_JAKARTA_ID,
};
